import _ from 'lodash';
import BlogService from 'web-core/src/blog-service';
import { BLOG_ITEMS_RECEIVED } from '../constants/blog';

const blogItemsReceived = (items, section = 'home') => ({
  type: BLOG_ITEMS_RECEIVED,
  items,
  section,
});

export const fetchBlogItems = options => (
  (dispatch, getState, { apiClient }) => {
    const svc = new BlogService({ client: apiClient });
    const section = _.get(options, 'params.section', 'home');
    const state = getState();
    if (state.blog.sections && state.blog.sections[section] && !options.refresh) {
      return Promise.resolve(state.blog.sections[section]);
    }

    return svc.get(options)
      .then((data) => {
        const { items } = data;
        dispatch(blogItemsReceived(items, section));
        return items;
      });
  }
);
